import HomeAuthenticatedHeroNPM from '@rotaryintl/component-account-hero';
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React, { useEffect, useState } from 'react';
import { MyRotary_getTokens } from '../../utilities/helper-functions';
import { createLink, tokenizeLink } from '../../utilities/link-helpers';
import { replaceTokens } from '../../utilities/token-helpers';

const HomeAuthenticatedHero = ({
  rendering,
  sitecoreContext,
  fields: { ProfileLink, ProfileLinkText, BackgroundColor, BackgroundImageDesktop, BackgroundImageMobile, Salutation, Role } = {},
}) => {
  const [tokens, setTokens] = useState({});
  useEffect(async () => {
    const tokensResponse = await MyRotary_getTokens(sitecoreContext?.language.toLowerCase());
    setTokens(tokensResponse);
  }, []);

  return (
    <HomeAuthenticatedHeroNPM
      backgroundColor={BackgroundColor?.fields?.Value?.value}
      backgroundImageDesktop={BackgroundImageDesktop?.value?.src}
      backgroundImageMobile={BackgroundImageMobile?.value?.src}
      backgroundImageAlt={BackgroundImageDesktop?.value?.alt}
      salutation={replaceTokens(Salutation?.value, tokens)}
      role={replaceTokens(Role?.value, tokens)}
      profileLink={tokenizeLink(createLink(ProfileLink, ProfileLinkText), tokens)}
      cardsPlaceholder={<Placeholder name="authenticated-hero-cards" rendering={rendering} />}
    />
  );
};

export default withSitecoreContext()(HomeAuthenticatedHero);
